module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/brand-by-category/brand-by-category.component.css
// module id = ./src/app/components/brand-by-category/brand-by-category.component.css
// module chunks = main